import { render } from "./project_footer.vue?vue&type=template&id=1023da3b"
import script from "./project_footer.vue?vue&type=script&lang=js"
export * from "./project_footer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patrikhubner/Dropbox/htdocs/netartmarathon/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__